import * as v from "valibot";
import { FilesystemJsSchema } from "./entity-schemas";

const SubRowsHashSchema = v.object({
  id: v.literal("sub-rows-hash"),
  hash: v.string(),
});
export type SubRowsHash = v.InferOutput<typeof SubRowsHashSchema>;
export const isSubRowsHash = (row: unknown) => v.is(SubRowsHashSchema, row);

const NoItemsIdSchema = v.literal("no-items");
export const NoItemsSchema = v.object({
  id: NoItemsIdSchema,
});
export type NoItems = v.InferOutput<typeof NoItemsSchema>;
export const isNoItems = (row: unknown) => v.is(NoItemsSchema, row);

export const FavoritesIdSchema = v.literal("favorites");
export const FavoritesSchema = v.object({
  id: FavoritesIdSchema,
  name: v.string(),
  items: v.array(FilesystemJsSchema),
});
export type Favorites = v.InferOutput<typeof FavoritesSchema>;
export const isFavorites = (row: unknown) => v.is(FavoritesSchema, row);

export const RecentsIdSchema = v.literal("recents");
export const RecentsSchema = v.object({
  id: RecentsIdSchema,
  name: v.string(),
});
export type Recents = v.InferOutput<typeof RecentsSchema>;
export const isRecents = (row: unknown) => v.is(RecentsSchema, row);
